export default "__VITE_ASSET__DLwz2c$$__"